export default {
    empty: {
        title: 'Looking for trend evaluations?',
        content: 'Create a new trend radar.',
        action: 'Create trend radar'
    }
}
